import React, { useRef, useState } from 'react';

function CustomizationModal({ product, onConfirm, onCancel }) {
  const [file, setFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);

  const handleFileSelect = (nextFile) => {
    if (nextFile) setFile(nextFile);
  };

  return (
    <div className="customization-overlay">
      <div className="customization-modal">
        <h3>Upload design file</h3>
        <p className="modal-product-name">{product.sku} — {product.description}</p>
        <p className="modal-help-text">This product needs customization. Upload the artwork file to continue.</p>

        <label
          className={`modal-file-upload ${dragActive ? 'drag-active' : ''} ${file ? 'has-file' : ''}`}
          onDragEnter={(e) => { e.preventDefault(); setDragActive(true); }}
          onDragOver={(e) => { e.preventDefault(); setDragActive(true); }}
          onDragLeave={(e) => {
            e.preventDefault();
            if (e.currentTarget.contains(e.relatedTarget)) return;
            setDragActive(false);
          }}
          onDrop={(e) => {
            e.preventDefault();
            setDragActive(false);
            handleFileSelect(e.dataTransfer.files?.[0] || null);
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
          </svg>
          <span className="modal-file-title">
            {file ? file.name : 'Drag and drop your design file here'}
          </span>
          <span className="modal-file-subtitle">
            {file ? 'File selected. You can replace it by dropping another file or selecting again.' : 'or choose a file from your computer'}
          </span>
          <button
            type="button"
            className="modal-file-picker-btn"
            onClick={(e) => {
              e.preventDefault();
              inputRef.current?.click();
            }}
          >
            Select File
          </button>
          <input
            ref={inputRef}
            type="file"
            style={{ display: 'none' }}
            onChange={(e) => handleFileSelect(e.target.files[0])}
            accept="image/*,.pdf,.ai,.eps,.cdr,.svg"
          />
        </label>
        {!file && <p className="modal-upload-error">Please upload your design file to continue.</p>}

        <div className="modal-actions">
          <button className="modal-cancel-btn" onClick={onCancel}>Cancel</button>
          <button
            className="modal-confirm-btn"
            disabled={!file}
            onClick={() => onConfirm(file)}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomizationModal;
